import { render, staticRenderFns } from "./PainelMelhoriasIGG.vue?vue&type=template&id=4d2ad7a8"
import script from "./PainelMelhoriasIGG.vue?vue&type=script&lang=js"
export * from "./PainelMelhoriasIGG.vue?vue&type=script&lang=js"
import style0 from "./PainelMelhoriasIGG.vue?vue&type=style&index=0&id=4d2ad7a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports